import { ofType } from "redux-observable";
import { of } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectQuestIds } from "../../../../selectors/selectQuestInfo";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionQuestInfoUpdate } from "../actionQuestInfo";
import { TypeActionQuest } from "../list/actionQuests";
export var epicQuestUpdate = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionQuest.Update), switchMap(function (action) {
        var state = state$.value;
        var uniqQuestIds = new Set(action.questIds.concat(selectQuestIds(state)));
        var questIds = Array.from(uniqQuestIds);
        return deps
            .netSend({
            id: CommandCode.QuestUpdate,
            props: {
                playerId: state.playerInfo.playerId,
                questId: questIds,
            },
        })
            .pipe(switchMap(function (res) {
            var quests = state.questInfo.quest;
            var questsMap = new Map();
            if (quests != undefined) {
                quests.forEach(function (val) {
                    questsMap.set(val.questId, val);
                });
            }
            if (res.quest !== undefined) {
                res.quest.map(function (value) {
                    if (questsMap.has(value.questId)) {
                        questsMap.set(value.questId, value);
                    }
                });
                res.quest = Array.from(questsMap.values());
            }
            return of(actionQuestInfoUpdate(res));
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/epics/epicQuestUpdate.ts
// module id = 1970
// module chunks = 3